// extracted by mini-css-extract-plugin
export default {"wrapper":"tu-z","addressLine":"uu-z","fullName":"vu-z"};